var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8105 1.41211L40.9936 2.74677L39.6589 8.9298",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81006 18.8982L20.075 10.0459L23.4797 14.4584L40.9938 2.74609",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9082 30.5022V14.3501",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9507 30.5024V18.1636",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0205 30.5023V16.7471",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0635 30.5022V18.6265",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1333 30.5023V21.4048",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.908 12.689C37.2076 13.3699 37.2349 13.5606 37.4528 14.2415C39.4412 20.697 37.7524 28.024 32.4955 32.9813C25.1412 39.927 13.5378 39.6001 6.5649 32.2186C-0.408031 24.8371 -0.0539374 13.261 7.32756 6.28805C13.1293 0.813212 21.5186 -0.140118 28.2463 3.26463C28.5187 3.40082 28.7911 3.53701 29.0362 3.70044",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlta);
export default __webpack_public_path__ + "static/media/icon_alta.9915962eb77490f51690f9bdc9535f2d.svg";
export { ForwardRef as ReactComponent };